// src/pages/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res  = await adminLogin(email, password);
      const data = res.data?.data;
      login(data.token, { email: data.email, name: data.name, role: data.role });
      navigate('/admin');  // ✅ Navigate to admin dashboard, not homepage
    } catch (err) {
      // ✅ Set error and STAY on login page — do not navigate away
      setError(err.response?.data?.message || 'Invalid email or password');
      setLoading(false);  // ensure loading is cleared so form stays usable
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <h1>🛡️ CivicSetu</h1>
          <p>Admin Panel</p>
        </div>

        <h2>Sign In</h2>

        {/* Error stays visible — no redirect */}
        {error && (
          <div className="error-msg" style={{
            background: '#fff5f5', border: '1px solid #f5c6cb',
            color: '#dc3545', padding: '10px 14px', borderRadius: 6,
            marginBottom: 16, fontSize: 14
          }}>
            ⚠️ {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              className="form-control"
              placeholder="admin@civicsetu.in"
              value={email}
              onChange={e => { setEmail(e.target.value); setError(''); }}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter password"
              value={password}
              onChange={e => { setPassword(e.target.value); setError(''); }}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
